import React from 'react';
import googleLogo from './google-white-logo.png';

function GoogleWhiteLogo({ ...props }) {
  return <img src={googleLogo} alt="googleWhiteLogo.png" {...props} />;
}

export default GoogleWhiteLogo;
